export default function preventDefaultAndStopPropagation<TElement = HTMLElement>(
    e?: React.MouseEvent<TElement>,
) {
    e?.preventDefault();
    e?.stopPropagation();
}
